import { storeHomePath } from './storePath';
/**
 * @function buildStoreGTMItems
 * @since 1.0.0
 */
export function buildStoreGTMItems(dealItems, currencyCode, language) {
    return dealItems
        .filter((item) => !item.proposed)
        .map((dealItem) => {
        var _a, _b;
        const saleItem = dealItem.item;
        const itemName = ((_b = (_a = saleItem === null || saleItem === void 0 ? void 0 : saleItem.translations) === null || _a === void 0 ? void 0 : _a.find((translation) => translation.language.code === language)) === null || _b === void 0 ? void 0 : _b.title) ||
            (saleItem === null || saleItem === void 0 ? void 0 : saleItem.title) ||
            '';
        return {
            currency: currencyCode,
            item_id: (saleItem === null || saleItem === void 0 ? void 0 : saleItem.sku) || dealItem.id,
            item_name: itemName,
            price: dealItem.price,
            quantity: dealItem.quantity
        };
    });
}
/**
 * @function sendStoreGTMEvent
 * @since 1.0.0
 */
export function sendStoreGTMEvent(eventName, ecommerceData) {
    if (typeof window === 'undefined') {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: eventName,
        ecommerce: ecommerceData
    });
}
/**
 * @function buildStoreStripeReturnPath
 * @since 1.0.0
 */
export function buildStoreStripeReturnPath(language, dealId, partnerSlug) {
    return `${storeHomePath(language, partnerSlug)}?dealId=${dealId}`;
}
